(() => {
  const clipPathString = `M2.263,2.277A14.277,14.277,0,0,1,6.319.233a3.642,3.642,0,0,1,2.11.151c1.233.359,3.226.964,4.384,1.3a4.084,4.084,0,0,0,2.841-.025C17.177,1.187,19.18.476,20.757.12a3.819,3.819,0,0,1,1.738.214c1.06.328,2.9.935,4.021,1.295a4.424,4.424,0,0,0,2.9.164C31.694,1.294,35.336.409,37.6.019a5.65,5.65,0,0,1,1.7.23c1.924.5,5.2,1.235,6.96,1.66a4.365,4.365,0,0,0,2.063-.076c1.8-.381,6.017-1.291,7.771-1.663a4.8,4.8,0,0,1,2.652.054C60.5.614,64.209,1.446,65.88,1.817a4.333,4.333,0,0,0,2,.117c1.958-.5,5.352-1.206,7.26-1.7A4.771,4.771,0,0,1,77.744.179c2.372.422,6.408,1.546,8.878,1.839C89.268,1.644,93.122.6,95.951.06a4.392,4.392,0,0,1,1.892.17c1.539.365,4.8,1.156,6.418,1.54a3.964,3.964,0,0,0,2.555-.013c1.312-.425,3.359-1.017,4.627-1.427a4,4,0,0,1,1.769-.22c1.507.312,3.179.929,4.705,1.364a4.685,4.685,0,0,0,3.554.183c1.306-.413,2.759-.85,4.046-1.254a5.224,5.224,0,0,1,1.7-.324,51.305,51.305,0,0,1,5.434,1.493,4.887,4.887,0,0,0,3.245.217c1.936-.45,4.049-.907,5.97-1.354a7.75,7.75,0,0,1,2.75-.381c1.873.372,5.04,1.26,6.979,1.717a4.553,4.553,0,0,0,1.946.2c2.359-.5,6.639-1.386,8.613-1.824a4.829,4.829,0,0,1,2.561.117c1.64.387,4.9,1.162,6.465,1.531a4.832,4.832,0,0,0,2.725.025c1.813-.4,5.866-1.3,7.506-1.65a4.5,4.5,0,0,1,2.312.013c1.577.35,5.349,1.213,7.134,1.613a4.9,4.9,0,0,0,2.744.031c1.728-.381,5.614-1.257,7.3-1.628a4.456,4.456,0,0,1,2.422,0c1.495.35,4.977,1.2,6.635,1.591a4.351,4.351,0,0,0,1.772.161c1.9-.441,4.283-1.241,6.128-1.726a3.971,3.971,0,0,1,2.466.176c1.129.356,2.964.967,4.024,1.291a4.093,4.093,0,0,0,2.864-.038c1.17-.343,3.078-.926,4.251-1.266a3.319,3.319,0,0,1,2.368-.016,22.358,22.358,0,0,1,2.854,1.43c1.394.841,2.006,2.684,2.775,3.987a2.629,2.629,0,0,1,.3,1.858c-.407,1.556-1.293,3.9-1.75,5.389a3.555,3.555,0,0,0,.032,2.756c.542,1.565,1.384,3.663,1.8,5.291a3.53,3.53,0,0,1-.237,1.723c-.555,1.78-1.5,4.107-1.9,5.918a3.768,3.768,0,0,0,.164,1.417c.416,1.946,1.536,5.458,1.99,7.556a3.9,3.9,0,0,1-.107,1.978c-.426,2.069-1.432,5.518-1.769,7.5a4.524,4.524,0,0,0,.136,1.528c.375,1.742,1.328,6.022,1.694,7.717a4.475,4.475,0,0,1,.145,1.383c-.366,2.022-1.3,5.959-1.791,8.2a4.711,4.711,0,0,0,.032,2.731c.385,1.559,1.208,4.791,1.561,6.233a4.234,4.234,0,0,1-.016,2.472c-.536,2.016-1.511,6.136-2,8.051a3.44,3.44,0,0,0,.057,1.8c.524,2.1,1.548,5.909,2.034,7.9a4,4,0,0,1-.088,2.2c-.391,1.761-1.261,5.6-1.624,7.235-.385,1.279.095,2.293.486,3.569.312.992.675,2.06.981,3.052.643,1.477.079,2.6-.331,4.085-.341,1.537-1.28,3.43-1.23,4.91a37.844,37.844,0,0,0,1.261,4.4c.382,1.3.886,2.409.344,3.688-.388,1.2-.845,2.476-1.246,3.682-.268,1.02-.839,2.022-.691,2.923.356,2.038,1.252,4.665,1.744,6.788.341,1.421.763,2.29.249,3.78-.508,2.1-1.129,4.422-1.637,6.495-.265,1.225-.539,1.672-.315,2.7.552,1.893,1.388,4.98,1.943,6.8a4.1,4.1,0,0,1,.063,2.589c-.523,2.476-1.81,6.907-2.094,9.175.4,2.617,1.8,6.032,2.286,8.69a5.207,5.207,0,0,1-.158,1.449c-.394,1.893-1.337,6.312-1.69,8.016a4.42,4.42,0,0,0,.044,2.3c.36,1.556,1.22,5.184,1.608,6.866a4.089,4.089,0,0,1,.12,1.959c-.457,1.928-1.429,4.97-1.933,6.888a3.948,3.948,0,0,0-.211,1.713c.5,1.969,1.429,4.41,2,6.309a3.83,3.83,0,0,1-.095,2.482c-.372,1.3-1.06,3.569-1.394,4.756a3.538,3.538,0,0,0-.05,2.139c.423,1.326.981,2.98,1.407,4.261a3.268,3.268,0,0,1,.1,2.1,30.873,30.873,0,0,1-1.362,3.25,3.317,3.317,0,0,1-1.388,1.543c-.905.551-2.135,1.014-3.062,1.477a3.055,3.055,0,0,1-2.372.277c-1.227-.353-3.251-1.2-4.529-1.613a3.251,3.251,0,0,0-2.725-.019c-1.038.353-2.179.85-3.229,1.232a4.056,4.056,0,0,1-3.479.309c-1.34-.432-3.772-1.25-4.986-1.638-1.3-.523-1.962-.167-3.406.18-1.93.491-4.046,1.1-6,1.6-1.34.444-2.3.066-3.643-.324-2.2-.57-4.989-1.458-7.112-1.975a3.406,3.406,0,0,0-1.839.167c-1.545.454-5.055,1.512-6.8,2.028a3.539,3.539,0,0,1-2.444.148c-1.854-.495-5.768-1.767-7.427-2.217a3.654,3.654,0,0,0-2.678.145c-1.766.472-3.882,1.14-5.7,1.638-1.457.4-2.422.888-3.841.353-2.466-.661-5.443-1.663-7.843-2.265a3.584,3.584,0,0,0-2,.243c-1.892.513-5.257,1.644-7.03,2.123-1.46.419-2.649-.274-4.182-.589-1.558-.416-3.2-.838-4.746-1.247a4.274,4.274,0,0,0-3.384.236c-1.227.444-2.655.917-3.857,1.342a3.536,3.536,0,0,1-2.933.047c-1.154-.387-3.16-1.093-4.365-1.5a3.624,3.624,0,0,0-2.157-.265c-1.5.482-3.586,1.172-5.144,1.729a3.488,3.488,0,0,1-2.063.255c-1.848-.548-4.226-1.7-6.084-2.29a2.847,2.847,0,0,0-1.75.076c-2.006.479-5.875,1.883-7.922,2.321a3.344,3.344,0,0,1-1.571-.183c-2.182-.561-6.109-1.9-8.442-2.356a3.956,3.956,0,0,0-1.375.233c-2.047.5-5.882,1.909-7.862,2.315a4,4,0,0,1-1.668-.2c-1.731-.438-5.522-1.414-7.213-1.843a5.159,5.159,0,0,0-1.381-.211c-2.3.419-5.822,1.546-7.947,2.082a4.023,4.023,0,0,1-2.488-.016c-1.889-.513-5.774-1.417-7.7-1.924a3.976,3.976,0,0,0-2.346.082c-1.709.441-5.519,1.443-7.143,1.861a4.545,4.545,0,0,1-1.347.2c-2.375-.387-6.033-1.594-8.493-2.139a3.345,3.345,0,0,0-2.176.2c-1.075.381-3.056,1.134-4.21,1.546a5.932,5.932,0,0,1-1.072.3,3.54,3.54,0,0,1-1.706-.3c-1.325-.476-3.766-1.392-5.03-1.843a3.009,3.009,0,0,0-1.662-.23c-1.8.557-3.419,1.361-5.112,2.006a2.679,2.679,0,0,1-2.561-.085c-1.526-.885-3.592-1.591-4.226-3.433-.47-1.335-1.325-2.545-1.362-3.912.2-1.553,1.217-3.487,1.716-5.027a3.663,3.663,0,0,0,.013-3.049C1.418,222.778.7,220.731.321,219.6a3.718,3.718,0,0,1,.076-2.86c.587-1.839,1.438-3.962,1.832-5.751a3.661,3.661,0,0,0-.164-1.373c-.413-1.928-1.567-5.424-2-7.474a3.756,3.756,0,0,1,.158-1.928c.514-1.792,1.384-5.169,1.9-7.017a3.9,3.9,0,0,0-.073-2.34C1.6,188.9.535,185.168.1,183.259a4.117,4.117,0,0,1,.057-2.287c.407-1.915,1.337-6.227,1.681-7.871.378-1.461-.208-2.6-.517-4.117C.967,167.5.564,165.933.21,164.453c-.53-1.424-.016-2.334.363-3.717.476-1.616,1.079-3.49,1.548-5.074.438-1.474.634-1.95.221-3.187-.508-1.8-1.716-6.019-2.167-7.641A3.722,3.722,0,0,1,.2,142.49c.435-1.669,1.441-5.439,1.861-7.068a3.687,3.687,0,0,0-.151-2.576c-.438-1.559-1.438-3.786-1.8-5.339a3.775,3.775,0,0,1,.237-2.013c.464-1.345,1.069-3.285,1.466-4.561a3.843,3.843,0,0,0-.132-2.428C1.226,116.78.365,114.414.056,112.8a3.781,3.781,0,0,1,.268-1.713c.4-1.172,1.167-3.32,1.577-4.517a3.664,3.664,0,0,0,.167-2.535C1.661,102.458.661,98.754.217,97.06a3.9,3.9,0,0,1-.142-2.076C.45,93.164,1.6,89.46,2.043,87.557a4.113,4.113,0,0,0-.013-2.633C1.592,83.22.63,79.541.2,77.875A4.472,4.472,0,0,1,0,76.341c.4-2.095,1.448-5.14,1.977-7.222a5.336,5.336,0,0,0,.284-1.594C1.819,65.094.655,61.1.144,58.921A3.768,3.768,0,0,1,0,57.418c.416-2.113,1.422-5.613,1.974-7.969a6.947,6.947,0,0,0,.293-1.672C1.85,45.424.74,41.931.188,39.72a4.187,4.187,0,0,1-.019-2.526c.508-1.946,1.261-5.6,1.728-7.628.2-1.169-.287-2.113-.574-3.323-.35-1.279-.757-2.655-1.1-3.934a4.063,4.063,0,0,1,.085-2.791c.2-.658.385-1.351.59-2.028.36-1.587,1.3-3.323.893-4.841C1.358,11.2.8,9.417.349,7.981A3.693,3.693,0,0,1,.141,6.343,11.935,11.935,0,0,1,1.491,3.3a4.518,4.518,0,0,1,.725-.989l.038-.038Z`;

  let objectsError = false;

  // Get moodboard ID from URL
  const params = new URL(document.location).searchParams;
  const paramsId = params.get('id');

  // Mood board listings page
  if (!customElements.get('mood-board-list')) {
    class MoodBoardList extends HTMLElement {
      constructor() {
        super();
        this.maxId = 0;
        this.grid = this.querySelector('.js-mood-board-grid');
        this.read();
      }

      read() {
        if (!this.grid) {
          return;
        }

        this.classList.add('loading');

        readRequest()
          .then(res => {
            this.grid.innerHTML = '';

            if (res === 'error') {
              return this.error();
            }

            this.data = res;

            // Create markup for adding new mood board
            const newHtml = `
              <div class="mood-board-listings__grid-item">
                <div class="mood-board-listings__grid-item-new js-moodboard-new-untitled">
                  <div class="mood-board-listings__grid-item-new-title">
                    ${window.icons.plus.replace('[class]','mood-board-listings__grid-item-new-icon')}
                    ${window.moodBoardStrings.new}
                  </div>
                </div>

                <div class="mood-board-listings__grid-item-actions js-mood-board-actions hidden">
                  <div class="mood-board-listings__grid-item-title-wrap">
                    <input type="text" class="mood-board-listings__grid-item-title-input js-mood-board-title" placeholder="${window.moodBoardStrings.createNewPlaceholder}">
                  </div>

                  <div class="mood-board-listings__grid-item-controls-wrap">
                    <button type="button" class="button button--white button--small js-mood-board-save">
                      ${window.moodBoardStrings.save}
                    </button>
                  </div>
                </div>
              </div>
            `;

            this.grid.innerHTML += newHtml;

            // Sort mood boards so most recent is first
            const orderedMoodboards = this.data?.customerMoodboards?.length
              ? this.data.customerMoodboards.sort((a, b) => a.id < b.id ? 1 : -1)
              : [];

            // Used to calculate ID for newly added mood boards. Taken from every
            // board, hidden ones included, so a new board can never reuse an id.
            this.maxId = orderedMoodboards.length ? Math.max(...orderedMoodboards.map((item) => item.id)) : 0;

            // Create markup for existing mood boards
            orderedMoodboards.filter(item => !isAbandoned(item)).forEach(item => {
              let backgroundImage = '';

              if (item.default_background_image && !item.mood_board) {
                backgroundImage = item.default_background_image;
              }

              const itemHtml = `
                <div class="mood-board-listings__grid-item">
                  <a href="${window.moodboardRoutes.detailsPage}?id=${item.id}" class="${item.mood_board ? 'mood-board-listings__grid-item-link' : 'mood-board-listings__grid-item-untitled'}" style="${backgroundImage ? `background-image:url('${backgroundImage}')` : ''}">

                    ${item.mood_board ? `
                      <div class="mood-board-listings__grid-item-preview js-mood-board-preview" >
                        <canvas data-mood-board-preview-id=${item.id} id="mood-board-${item.id}" class="mood-board-listings__preview"></canvas>
                      </div>
                    ` : ''}
                  </a>

                  <div class="mood-board-listings__grid-item-actions js-mood-board-actions" data-mood-board-id=${item.id}>
                    <div class="mood-board-listings__grid-item-title-wrap">
                      <input type="text" class="mood-board-listings__grid-item-title-input js-mood-board-title edit-show" value="${item.title}" placeholder="${window.moodBoardStrings.createNewPlaceholder}">

                      <h3 class="mood-board-listings__grid-item-title edit-hide${hasTitle(item) ? '' : ' is-untitled'}">${displayTitle(item, orderedMoodboards)}</h3>
                    </div>

                    <div class="mood-board-listings__grid-item-controls-wrap">
                      <button
                        type="button"
                        class="button button--white button--small js-mood-board-save edit-show"
                        data-mood-board-id="${item.id}"
                      >
                        ${window.moodBoardStrings.save}
                      </button>

                      <button type="button" class="mood-board-listings__grid-item-controls-button js-mood-board-edit edit-hide">
                        ${window.icons.edit.replace('[class]', 'mood-board-listings__grid-item-controls-button-icon')}
                        ${window.moodBoardStrings.edit}
                      </button>
                      <button
                        type="button"
                        class="mood-board-listings__grid-item-controls-button js-mood-board-delete edit-hide"
                        data-mood-board-id="${item.id}"
                      >
                        ${window.icons.bin.replace('[class]', 'mood-board-listings__grid-item-controls-button-icon')}
                        ${window.moodBoardStrings.remove}
                      </button>
                    </div>
                  </div>
                </div>
              `;

              this.grid.innerHTML += itemHtml;
            });

            this.classList.remove('initial-loading', 'loading');
            this.addListeners();
            this.updatePreviewImages();
          })
          .catch(error => console.error(error));
      }

      // Create new mood board
      create(title, newMoodBoard = false, options = {}) {
        document.dispatchEvent(new Event('alert:clear'));

        if ((this.data?.customerMoodboards || []).filter(board => !isAbandoned(board)).length > 12) {
          return document.dispatchEvent(new CustomEvent('alert:show', {
            detail: {
              message: window.moodBoardStrings.limit,
              status: 'error',
            },
          }));
        }

        const moodBoardData = {
          id: this.maxId + 1,
          title: stripHtml(title),
        };

        if (newMoodBoard && window.moodboardDefaultBackgroundImage) {
          moodBoardData.default_background_image = window.moodboardDefaultBackgroundImage;
        }

        this.data.customerMoodboards.push(moodBoardData);

        this.write(moodBoardData, options);
      }

      // Update existing mood board
      update(moodboardId, title) {
        const index = this.data.customerMoodboards.findIndex(({ id }) => parseInt(id) == parseInt(moodboardId));

        if (index === -1) {
          return;
        }

        this.data.customerMoodboards[index].title = stripHtml(title);

        this.write(this.data.customerMoodboards[index]);
      }

      onSave(id, title) {
        document.dispatchEvent(new Event('alert:clear'));

        if (!title || stripHtml(title.value) === '') {
          return document.dispatchEvent(new CustomEvent('alert:show', {
            detail: {
              message: window.moodBoardStrings.enterTitle,
              status: 'error',
            },
          }));
        }

        if (id) {
          return this.update(id, stripHtml(title.value));
        }

        // A new board: only made once it has a name, with the default background,
        // and opened straight away.
        this.create(stripHtml(title.value), true, { open: true });
      }

      // Delete mood board
      delete(moodboardId) {
        const index = this.data.customerMoodboards.findIndex(({ id }) => id == moodboardId);

        if (index === -1) {
          return;
        }

        this.data.customerMoodboards.splice(index, 1);

        this.classList.add('loading');

        removeRequest(moodboardId)
          .then(() => this.read())
          .catch(error => console.log(error));
      }

      // options.open: go straight into the board once it is saved, rather than
      // redrawing the list — used when a new board has just been named.
      write(moodboard, options = {}) {
        this.classList.add('loading');

        const moodboardToWrite = this.data.customerMoodboards.filter(({ id }) => parseInt(id) === parseInt(moodboard.id))?.[0] ?? null;

        if (!moodboardToWrite) {
          document.dispatchEvent(new CustomEvent('alert:show', {
            detail: {
              message: window.moodBoardStrings.error,
              status: 'error',
            },
          }));

          return;
        }

        writeRequest({
          metafield: this.data.metafield,
          moodboard: moodboardToWrite,
        })
          .then(() => {
            if (options.open) {
              window.location.href = `${window.moodboardRoutes.detailsPage}?id=${moodboardToWrite.id}`;
              return;
            }

            this.read();
          })
          .catch(error => console.error(error));
      }

      // Generates previews for existing mood boards, creates a new canvas element for the preview
      updatePreviewImages() {
        const previews = document.querySelectorAll('.js-mood-board-preview');

        previews.forEach((el) => {
          const canvasElement = el.querySelector('canvas');

          if (!canvasElement) {
            return;
          }

          const canvasElementId = canvasElement.id;
          const previewId = canvasElement.getAttribute('data-mood-board-preview-id')

          if (!canvasElementId || !previewId) {
            return;
          }

          const index = this.data.customerMoodboards.findIndex(({ id }) => id == previewId);

          if (index === -1) {
            return;
          }

          const moodBoard = this.data.customerMoodboards[index].mood_board;

          if (!moodBoard) {
            return;
          }

          const title = this.data.customerMoodboards[index].title;

          (() => {
            const canvas = new fabric.StaticCanvas(canvasElementId);

            canvas.loadFromJSON(moodBoard, () => {
              canvas.setDimensions({ width: 1604, height: 802 });

              // 8 boards (24 Sep 2026) have items on the canvas but no background.
              // Without this guard the call threw and the tile was left showing the
              // half-drawn canvas instead of its preview picture.
              if (canvas.backgroundImage) {
                canvas.backgroundImage.scaleToWidth(canvas.width);
                canvas.backgroundImage.scaleToHeight(canvas.height);
              }

              const dataUrl = canvas.toDataURL({
                format: 'jpeg',
                quality: 0.6
              });

              el.innerHTML = `<img src="${dataUrl}" alt="${title ? title : ''}" class="mood-board-listings__preview">`
            });
          })();
        })
      }

      // Add event listeners for mood board listing items
      addListeners() {
        const actions = this.querySelectorAll('.js-mood-board-actions');
        const newUntitled = this.querySelector('.js-moodboard-new-untitled');

        actions.forEach((action) => {
          const id = action.getAttribute('data-mood-board-id');
          const title = action.querySelector('.js-mood-board-title');

          const editButtons = action.querySelectorAll('.js-mood-board-edit');
          editButtons.forEach(el => el.addEventListener('click', () => action.classList.add('edit')));

          const deleteButtons = action.querySelectorAll('.js-mood-board-delete');
          deleteButtons.forEach(el => {
            el.addEventListener('click', () => {
              if (confirm(window.moodBoardStrings.confirmRemove)) {
                this.delete(el.dataset.moodBoardId);
              }
            })
          });

          if (!title) {
            return;
          }

          const saveButtons = action.querySelectorAll('.js-mood-board-save');
          saveButtons.forEach(el => el.addEventListener('click', () => this.onSave(id, title)));

          title.addEventListener('keydown', e => {
            if (e.key.toLowerCase() !== 'enter') {
              return;
            }

            this.onSave(id, title);
          });
        })

        if (!newUntitled) {
          return;
        }

        // Create New no longer makes an unnamed board. It opens the name field
        // under the tile, and the board is made when that is saved (onSave).
        const newActions = newUntitled.parentElement.querySelector('.js-mood-board-actions');
        const newTitle = newActions ? newActions.querySelector('.js-mood-board-title') : null;

        if (newTitle && this.dataset.namePlaceholder) {
          newTitle.placeholder = this.dataset.namePlaceholder;
        }

        const stopNaming = () => {
          newUntitled.classList.remove('is-naming');
          newActions.classList.add('hidden');
          newTitle.value = '';
        };

        newUntitled.addEventListener('click', () => {
          if (!newActions || !newTitle) {
            return;
          }

          newUntitled.classList.add('is-naming');
          newActions.classList.remove('hidden');
          newTitle.focus();
        });

        if (newTitle) {
          newTitle.addEventListener('keydown', e => {
            if (e.key === 'Escape') {
              stopNaming();
              newUntitled.focus();
            }
          });
        }
      }

      error() {
        this.innerHTML = `
          <div class="page-width">
            <p>${window.moodBoardStrings.error}</p>
          </div>
        `;

        this.classList.remove('initial-loading', 'loading');
      }
    }

    customElements.define('mood-board-list', MoodBoardList);
  }

  // Mood board details page
  if (!customElements.get('mood-board')) {
    class MoodBoard extends HTMLElement {
      constructor() {
        super();

        this.activeCustomerId = this.dataset.activeCustomerId;

        const queryParams = new URLSearchParams(window.location.href.split('?')[1]);

        if (!queryParams.has('id')) {
          return;
        }

        // this.read();
        this.readSingle(queryParams.get('id'));
        this.addAllButton = this.querySelector('.js-mood-board-add-all');
        this.initialLoad = true;
        this.saving = false;
        this.addBeforeUnloadListener();
        this.addListeners();

        if (this.addAllButton) {
          this.addAllButton.addEventListener('click', () => this.addAll());
        }

        document.addEventListener('moodboard:refresh', () => {
          // this.read();
          this.readSingle(queryParams.get('id'), true);
        });
      }

      // Show warning message if user tries to leave page while mood board is saving
      addBeforeUnloadListener() {
        window.addEventListener('beforeunload', e => {
          if (this.saving) {
            e.preventDefault();
          }
        });
      }

      // Add all products from favourites to the cart
      addAll() {
        const productCards = this.querySelectorAll('.js-mood-board-product-card');
        const data = { items: [] };

        this.addAllButton.setAttribute('disabled', 'disabled');

        document.dispatchEvent(new Event('alert:clear'));

        productCards.forEach(el => {
          const id = el.getAttribute('data-variant-id');
          const quantity = el.getAttribute('data-product-quantity');

          if (!id) {
            return;
          }

          data.items.push({
            id,
            quantity
          });
        })

        fetch(`${routes.cart_add_url}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        })
          .then(res => {
            if (!res.ok) {
              document.dispatchEvent(
                new CustomEvent('alert:show', {
                  detail: {
                    message: window.cartStrings.error,
                    status: 'error',
                  },
                })
              );
            } else {
              publish(PUB_SUB_EVENTS.cartAdd);
            }
          })
          .catch(e => console.error(e))
          .finally(() => this.addAllButton.removeAttribute('disabled'))
      }

      read(updateFavourites = true) {
        readRequest()
          .then(moodboards => {
            // Find active moodboard by using ID from page URL
            this.data = moodboards;
            this.moodBoardIndex = this.data.customerMoodboards.findIndex(({ id }) => id == paramsId);

            if (this.moodBoardIndex === -1) {
              const app = this.querySelector('.js-mood-board-app');
              const errorMessage = this.querySelector('.js-mood-board-error-message');

              // Display error message if mood board not found
              if (errorMessage) {
                errorMessage.innerHTML = `
                  <h1 class="mood-board__hero-title">${window.moodBoardStrings.placeholderTitle}</h1>
                  <p class="mood-board__hero-description">${window.moodBoardStrings.notFound}</p>
                  <a href="${window.moodboardRoutes.listingsPage}" class="button button--white">${window.moodBoardStrings.myMoodboards}</a>
                `;
              }

              this.classList.add('error');
              this.classList.remove('initial-loading', 'loading');

              if (app) {
                app.innerHTML = '';
              }

              return;
            }

            this.classList.add('loading');
            this.classList.remove('edit');

            this.moodBoard = this.data.customerMoodboards[this.moodBoardIndex];

            const deleteButtons = this.querySelectorAll('.js-mood-board-delete');
            deleteButtons.forEach(el => {
              el.dataset.moodBoardId = this.moodBoard.id;
            });

            if (updateFavourites) {
              const favourites = document.querySelector('.js-mood-board-favourites');

              if (favourites) {
                favourites.innerHTML = '';
              }

              const products = this.moodBoard.products;

              if (this.addAllButton) {
                if (products.length) {
                  this.addAllButton.removeAttribute('disabled');
                } else {
                  this.addAllButton.setAttribute('disabled', 'disabled');
                }
              }

              // Create markup for products in favourites section
              if (favourites && products.length) {
                let requests = [];

                favourites.classList.add('loading');

                products.forEach(product => {
                  if (!product.handle) {
                    return;
                  }

                  requests.push(fetch(`/products/${product.handle}`));
                });

                Promise.all(requests)
                  .then(responses => {
                    return Promise.all(responses.map(response => {
                      if (response.ok) {
                        return response.text();
                      }
                    }))
                  })
                  .then(products => {
                    products.forEach((product) => {
                      const parser = new DOMParser();
                      const productHtml = parser.parseFromString(product, "text/html");
                      const moodBoardProduct = productHtml.querySelector('.js-mood-board-product-card');

                      if (favourites && moodBoardProduct) {
                        favourites.innerHTML += `
                          <div class="mood-board__tabs-grid-item">
                            ${moodBoardProduct.innerHTML}
                          </div>
                        `
                      }
                    });
                  })
                  .finally(() => {
                    if (updateFavourites) {
                      this.addDynamicContentListeners();
                    }

                    favourites.classList.remove('loading');
                  })
              } else if (favourites) {
                // Display message if no products have been added to favourites
                favourites.innerHTML = `
                  <div class="mood-board__no-products">
                    <p>${window.moodBoardStrings.noProducts}</p>
                    <a href="${window.moodboardRoutes.browseCollection}" class="button button--white button--small">${window.moodBoardStrings.browseProducts}</a>
                  </div>
                `;

                // Remove any existing browse more button when no products
                const tabsContent = favourites.closest('.mood-board__tabs-content');
                if (tabsContent) {
                  const existingButton = tabsContent.querySelector('.mood-board__browse-more');
                  if (existingButton) {
                    existingButton.remove();
                  }
                }
              }
            }

            const title = this.querySelector('.js-mood-board-title');

            if (title) {
              title.innerHTML = this.moodBoard.title;
            }

            const titleInput = this.querySelector('.js-mood-board-title-input');

            if (titleInput) {
              titleInput.value = this.moodBoard.title;
            }

            this.classList.remove('initial-loading', 'loading');
            this.applyTitleGate();

            if (this.initialLoad) {
              this.createCanvas();
            }

            this.initialLoad = false;
          })
          .catch(error => console.error(error));
      }

      readSingle(id, updateFavourites = true) {
        readSingleRequest(id)
          .then(({ moodboard, metafield }) => {
            this.classList.add('loading');
            this.classList.remove('edit');

            this.data = {
              metafield,
              customerMoodboards: [moodboard],
            };

            this.moodBoardIndex = 0;
            this.moodBoard = this.data.customerMoodboards[0];

            if (!this.moodBoard) {
              const app = this.querySelector('.js-mood-board-app');
              const errorMessage = this.querySelector('.js-mood-board-error-message');

              // Display error message if mood board not found
              if (errorMessage) {
                errorMessage.innerHTML = `
                  <h1 class="mood-board__hero-title">${window.moodBoardStrings.placeholderTitle}</h1>
                  <p class="mood-board__hero-description">${window.moodBoardStrings.notFound}</p>
                  <a href="${window.moodboardRoutes.listingsPage}" class="button button--white">${window.moodBoardStrings.myMoodboards}</a>
                `;
              }

              this.classList.add('error');
              this.classList.remove('initial-loading', 'loading');

              if (app) {
                app.innerHTML = '';
              }

              return;
            }

            if (updateFavourites) {
              const favourites = document.querySelector('.js-mood-board-favourites');

              if (favourites) {
                favourites.innerHTML = '';
              }

              const products = this.moodBoard.products;

              if (this.addAllButton) {
                if (products.length) {
                  this.addAllButton.removeAttribute('disabled');
                } else {
                  this.addAllButton.setAttribute('disabled', 'disabled');
                }
              }

              // Create markup for products in favourites section
              if (favourites && products.length) {
                let requests = [];

                favourites.classList.add('loading');

                products.forEach(product => {
                  if (!product.handle) {
                    return;
                  }

                  requests.push(fetch(`/products/${product.handle}`));
                });

                Promise.all(requests)
                  .then(responses => {
                    return Promise.all(responses.map(response => {
                      if (response.ok) {
                        return response.text();
                      }
                    }))
                  })
                  .then(products => {
                    products.forEach((product) => {
                      const parser = new DOMParser();
                      const productHtml = parser.parseFromString(product, "text/html");
                      const moodBoardProduct = productHtml.querySelector('.js-mood-board-product-card');

                      if (favourites && moodBoardProduct) {
                        favourites.innerHTML += `
                          <div class="mood-board__tabs-grid-item">
                            ${moodBoardProduct.innerHTML}
                          </div>
                        `
                      }
                    });

                    // Add browse more products button after the grid but within the tab content
                    const tabsContent = favourites.closest('.mood-board__tabs-content');
                    if (tabsContent) {
                      // Remove any existing browse more button
                      const existingButton = tabsContent.querySelector('.mood-board__browse-more');
                      if (existingButton) {
                        existingButton.remove();
                      }
                      
                      // Insert the link after the grid
                      favourites.insertAdjacentHTML('afterend', `
                        <div class="mood-board__browse-more">
                          <a href="${window.moodboardRoutes.browseCollection}">BROWSE MORE PRODUCTS</a>
                        </div>
                      `);
                    }
                  })
                  .finally(() => {
                    if (updateFavourites) {
                      this.addDynamicContentListeners();
                    }

                    favourites.classList.remove('loading');
                  })
              } else if (favourites) {
                // Display message if no products have been added to favourites
                favourites.innerHTML = `
                  <div class="mood-board__no-products">
                    <p>${window.moodBoardStrings.noProducts}</p>
                    <a href="${window.moodboardRoutes.browseCollection}" class="button button--white button--small">${window.moodBoardStrings.browseProducts}</a>
                  </div>
                `;

                // Remove any existing browse more button when no products
                const tabsContent = favourites.closest('.mood-board__tabs-content');
                if (tabsContent) {
                  const existingButton = tabsContent.querySelector('.mood-board__browse-more');
                  if (existingButton) {
                    existingButton.remove();
                  }
                }
              }
            }

            const title = this.querySelector('.js-mood-board-title');

            if (title) {
              title.innerHTML = this.moodBoard.title;
            }

            const titleInput = this.querySelector('.js-mood-board-title-input');

            if (titleInput) {
              titleInput.value = this.moodBoard.title;
            }

            this.classList.remove('initial-loading', 'loading', 'edit');
            this.applyTitleGate();

            if (this.initialLoad) {
              this.createCanvas();
            }

            this.initialLoad = false;

            const deleteButtons = this.querySelectorAll('.js-mood-board-delete');
            deleteButtons.forEach(el => {
              el.dataset.moodBoardId = this.moodBoard.id;
            });
          })
          .catch(error => console.error(error));
      }

      // A board with no name opens in the header's edit mode, with the tabs and
      // canvas locked (mood-board.css) until it is saved. Covers boards made
      // before naming was required, and any old link to one. Saving goes through
      // onSave -> update -> readSingle, which runs this again and lifts it.
      applyTitleGate() {
        const untitled = !this.moodBoard || stripHtml(this.moodBoard.title || '').trim() === '';

        this.classList.toggle('needs-title', untitled);

        if (!untitled) {
          return;
        }

        this.classList.add('edit');

        const titleInput = this.querySelector('.js-mood-board-title-input');

        if (titleInput) {
          window.requestAnimationFrame(() => titleInput.focus());
        }
      }

      // Update mood board
      update(title) {
        this.classList.add('loading');
        this.data.customerMoodboards[this.moodBoardIndex]['title'] = stripHtml(title);
        this.moodBoard = this.data.customerMoodboards[this.moodBoardIndex];

        writeRequest({
          metafield: this.data.metafield,
          moodboard: this.moodBoard,
        })
          .then(() => this.readSingle(this.moodBoard.id, false))
          .catch(error => console.error(error));
      }

      // Delete mood board
      delete(moodboardId) {
        this.classList.add('loading');
        this.data.customerMoodboards.splice(this.moodBoardIndex, 1);

        removeRequest(moodboardId)
          .then(() => this.readSingle(moodboardId, true))
          .catch(error => console.error(error));
      }

      // Delete product from favourites
      deleteProduct(id) {
        const productIndex = this.data.customerMoodboards[this.moodBoardIndex].products.findIndex(product => product.id == id);

        if (productIndex === -1) {
          return;
        }

        this.data.customerMoodboards[this.moodBoardIndex].products.splice(productIndex,  1);
        this.classList.add('loading');
        this.saving = true;

        writeRequest({
          metafield: this.data.metafield,
          moodboard: this.data.customerMoodboards[this.moodBoardIndex],
        })
          .then(() => {
            this.readSingle(this.moodBoard.id, true);
            this.saving = false;
          })
          .catch((error) => console.error(error));
      }

      onSave(title) {
        document.dispatchEvent(new Event('alert:clear'));

        if (!title || stripHtml(title.value) === '') {
          return document.dispatchEvent(new CustomEvent('alert:show', {
            detail: {
              message: window.moodBoardStrings.enterTitle,
              status: 'error',
            },
          }));
        }

        this.update(stripHtml(title.value));
      }

      // Add event listeners to product cards in favourites
      addDynamicContentListeners() {
        const cardImages = this.querySelectorAll('.js-mood-board-product-card-image');

        cardImages.forEach(el => {
          el.addEventListener('click', () => {
            if (!el.src || !el.id) {
              return;
            }

            this.addImage(el);
          });
        });

        const productDeleteButtons = this.querySelectorAll('.js-mood-board-product-delete');

        productDeleteButtons.forEach(el => {
          el.addEventListener('click', () => {
            const id = el.getAttribute('data-product-id');

            if (!id) {
              return;
            }

            if (confirm(window.moodBoardStrings.confirmProductRemove)) {
              this.deleteProduct(id)
            }
          })
        })
      }

      // Add event listeners to controls in header section
      addListeners() {
        const titleInput = this.querySelector('.js-mood-board-title-input');
        const backgroundCardImages = this.querySelectorAll('.js-mood-board-background-card-image');

        backgroundCardImages.forEach(el => {
          el.addEventListener('click', () => {
            if (!el.nextElementSibling) {
              return;
            }

            this.addBackgroundImage(el.nextElementSibling);
            this.scrollCanvasIntoView();
          });
        });

        const editButtons = this.querySelectorAll('.js-mood-board-edit');
        editButtons.forEach(el => el.addEventListener('click', () => this.classList.add('edit')));

        const deleteButtons = this.querySelectorAll('.js-mood-board-delete');
        deleteButtons.forEach(el => {
          el.addEventListener('click', () => {
            if (confirm(window.moodBoardStrings.confirmRemove)) {
              this.delete(el.dataset.moodBoardId);
            }
          })
        });

        const printButtons = this.querySelectorAll('.js-mood-board-print');
        printButtons.forEach(el => el.addEventListener('click', () => this.printCanvas()));

        const shareButtons = this.querySelectorAll('.js-mood-board-share');
        shareButtons.forEach(el => el.addEventListener('click', () => {
          let URL = window.moodboardRoutes.generateSharePageUrl(this.activeCustomerId, this.moodBoard.id);
          if (el.dataset.param?.length > 0) {
            if (URL.includes('?')) {
              URL += `&${el.dataset.param}`;
            } else {
              URL += `?${el.dataset.param}`;
            }
          }
          window.location.href = URL;
        }));

        const saveImageButtons = this.querySelectorAll('.js-mood-board-save-image');
        saveImageButtons.forEach(el => el.addEventListener('click', () => this.shareCanvas()));

        if (!titleInput) {
          return;
        }

        const saveButtons = this.querySelectorAll('.js-mood-board-save');
        saveButtons.forEach(el => el.addEventListener('click', () => this.onSave(titleInput)));

        titleInput.addEventListener('keydown', e => {
          if (e.key.toLowerCase() !== 'enter') {
            return;
          }

          this.onSave(titleInput);
        });
      }

      // Create mood board canvas
      createCanvas() {
        this.canvasElement = this.querySelector('.js-mood-board-canvas-container');

        if (!this.canvasElement) {
          return;
        }

        this.canvas = new fabric.Canvas('mood-board-canvas', {
          hoverCursor: 'pointer',
          selection: false,
          targetFindTolerance: 2,
          width: this.canvasElement.clientWidth,
          height: this.canvasElement.clientHeight,
          preserveObjectStacking: true,
          allowTouchScrolling: true,
        });

        this.addCanvasListeners();

        if (this.moodBoard.mood_board) {
          this.loadCanvasJSON();

          if (!this.moodBoard.mood_board.backgroundImage) {
            if (this.moodBoard.default_background_image) {
              this.addBackgroundImage(
                this.moodBoard.default_background_image,
                typeof this.moodBoard.default_background_image === 'string'
                  ? true
                  : false
              );
            }
          }
        } else {
          if (this.moodBoard.default_background_image) {
            this.addBackgroundImage(
              this.moodBoard.default_background_image,
              typeof this.moodBoard.default_background_image === 'string'
                ? true
                : false
            );
          }
        }

        // Update canvas control styles
        fabric.Object.prototype.transparentCorners = false;
        fabric.Object.prototype.cornerColor = '#454d4f';
        fabric.Object.prototype.borderColor = '#454d4f';
        fabric.Object.prototype.cornerStyle = 'square';
      }

      // Add listeners to canvas
      addCanvasListeners() {
        const _this = this;

        this.canvas.on({
          'object:moving': e => {
            e.target.opacity = 0.5;
          },
          'object:modified': e => {
            e.target.opacity = 1;

            if (!e.target.isOnScreen()) {
              e.target.top = 64;
              e.target.left = 64;
              e.target.setCoords();
            }

            _this.saveCanvas();
          },
        });

        window.addEventListener('resize', () => this.resize());
      }

      // Handle adding images to canvas
      addImage(image) {
        if (!image) {
          return;
        }

        const maxPercentage = 0.2; // Set the max percentage of canvas size
        const canvasWidth = this.canvas.width;
        const canvasHeight = this.canvas.height;

        // Calculate the maximum allowed dimensions based on the canvas size
        const maxWidth = canvasWidth * maxPercentage;
        const maxHeight = canvasHeight * maxPercentage;

        // Calculate the scaling factors
        const scaleX = maxWidth / image.width;
        const scaleY = maxHeight / image.height;

        // Use the smaller scale to maintain the aspect ratio
        const scale = Math.min(scaleX, scaleY);

        const randomXAdjustment = Math.floor(Math.random() * 81) - 40;
        const randomYAdjustment = Math.floor(Math.random() * 81) - 40;

        const position = {
          left: (this.canvas.width / 2) - (image.width * scaleX / 2) + randomXAdjustment,
          top: (this.canvas.height / 2) - (image.height * scaleY / 2) + randomYAdjustment,
        };

        const imageProperties = {
          left: position.left,
          top: position.top,
        }

        const imageBorderType = image.dataset.imageBorderType;

        if (imageBorderType === 'solid') {
          imageProperties.stroke = 'white';
          imageProperties.strokeWidth = 6;
        }

        // Adds drop shadow to all images
        imageProperties.shadow = new fabric.Shadow({
          color: 'rgba(44,56,59,0.4)',
          blur: 15,
          offsetX: 10,
          offsetY: 10,
        });

        const imageObject = new fabric.Image(image, imageProperties);

        imageObject.scaleToWidth(240);

        if (imageBorderType === 'wavy') {
          imageObject.clipPath = new fabric.Path(clipPathString, {
            scaleX: 1.66,
            scaleY: 1.66,
            top: (imageObject.width * -0.5),
            left: (imageObject.height * -0.5),
          });
        }


        this.canvas.add(imageObject);
        this.canvas.setActiveObject(imageObject);

        this.updateControls(imageObject);
        this.addDeleteButton();
        this.addSendToBackButton();
        this.addBringToFrontButton();
        this.saveCanvas();
        this.scrollCanvasIntoView();
      }

      updateControls(imageObject, scale) {
        imageObject.setControlsVisibility({
          mb: false,
          ml: false,
          mr: false,
          mt: false,
          mtr: false,
        });

        if (scale) {
          fabric.Object.prototype.set({
            borderColor: '#454d4f',
            borderScaleFactor: (1 / scale),
          });

          fabric.Object.prototype._drawControl = controlHandles;
          fabric.Object.prototype.cornerSize = 10 * (1 / scale);

          function controlHandles (control, ctx, methodName, left, top) {
            if (!this.isControlVisible(control)) {
              return
            }

            const size = this.cornerSize;

            ctx.beginPath();
            ctx.arc(left + size / 2, top + size / 2, size / 2, 0, 2 * Math.PI, false);
            ctx.fillStyle = '#454d4f';
            ctx.fill();
            ctx.lineWidth = 4 * (1 / scale);
            ctx.strokeStyle = '#454d4f';
            ctx.stroke();
          }
        }
      }

      scrollCanvasIntoView() {
        const header = document.querySelector('.js-header-wrapper');
        const headerHeight = header ? header.offsetHeight : 0;
        const lowerCanvas = this.canvas.lowerCanvasEl;
        const canvasRect = lowerCanvas.getBoundingClientRect();
        const top = canvasRect.top;
        const offset = top - headerHeight - 32;

        if (top + (window.innerHeight / 2) > window.innerHeight) {
          window.scrollTo({
            top: offset,
            behavior: 'smooth',
          });
        }
      }

      // Handle updating background image of canvas
      addBackgroundImage(backgroundImage, fromURL = false) {
        if (!backgroundImage) {
          return;
        }

        const settings = image => ({
          originX: 'left',
          originY: 'top',
          scaleX: this.canvas.width / image.width,
          scaleY: this.canvas.height / image.height,
        });

        if (fromURL) {
          fabric.Image.fromURL(backgroundImage, image => {
            this.canvas.setBackgroundImage(
              backgroundImage,
              this.canvas.renderAll.bind(this.canvas),
              settings(image)
            );
            this.saveCanvas(image);
          });
        } else {
          const backgroundImageObject = new fabric.Image(backgroundImage);
          this.canvas.setBackgroundImage(
            backgroundImageObject,
            this.canvas.renderAll.bind(this.canvas),
            settings(backgroundImageObject)
          );
          this.saveCanvas();
        }
      }

      // Handle resizing canvas
      resize() {
        const canvasOuter = this.querySelector('.js-mood-board-canvas-outer');
        const appInner = this.querySelector('.js-mood-board-app-inner');

        const scale = (appInner.offsetWidth) / 1604;

        this.canvas.discardActiveObject().renderAll();

        this.canvasElement.style.transform = `scale(${scale})`;
        this.canvasElement.style.transformOrigin = `top left`;
        canvasOuter.style.width = `${1604 * scale}px`;
        canvasOuter.style.height = `${802 * scale}px`;

        this.scaleControls(scale);
        this.canvas.requestRenderAll.bind(this.canvas);
      }

      scaleControls(scale) {
        const objects = this.canvas.getObjects();

        objects.forEach(object => {
          this.updateControls(object, scale);
          this.addSendToBackButton(scale);
          this.addBringToFrontButton(scale);
          this.addDeleteButton(scale);
        });
      }

      // Add delete button to image elements that have been added to the canvas
      addDeleteButton(scale = 1) {
        const _this = this;

        if (scale === 0) {
          scale = 1;
        }

        fabric.Object.prototype.controls.deleteControl = new fabric.Control({
          x: 0.5,
          y: -0.5,
          sizeX: 32 * (1 / scale),
          sizeY: 32 * (1 / scale),
          offsetX: -16 * (1 / scale),
          offsetY: -32 * (1 / scale),
          cursorStyle: 'pointer',
          mouseUpHandler: deleteObject,
          render: renderIcon,
          cornerSize: 0
        });

        // Handle deleting image
        function deleteObject(_eventData, transform) {
          const target = transform.target;

          _this.canvas.remove(target);
          _this.canvas.requestRenderAll.bind(_this.canvas);
          _this.saveCanvas();
        }

        // Create the delete button
        function renderIcon(ctx, left, top, _styleOverride, fabricObject) {
          const deleteIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='33' height='33' viewBox='0 0 33 33'%3E%3Cg id='Btn' transform='translate(-0.5)'%3E%3Crect id='Rectangle_5' data-name='Rectangle 5' width='32' height='32' rx='3.5' transform='translate(1 0.5)' fill='%23424b4d' stroke='%23424b4d' stroke-width='1'/%3E%3Crect id='Rectangle_6' data-name='Rectangle 6' width='32' height='32' rx='3.5' transform='translate(1 0.5)' fill='none' stroke='%23424b4d' stroke-width='1'/%3E%3Cpath id='Path_5' data-name='Path 5' d='M16.889,17.14,23.64,24l.637-.633L17.519,16.5l6.759-6.867L23.64,9l-6.752,6.86L10.137,9,9.5,9.633,16.259,16.5,9.5,23.367l.637.633Z' fill='%23fefdfc' fill-rule='evenodd'/%3E%3C/g%3E%3C/svg%3E%0A";

          const size = 32 * (1 / scale);
          const img = document.createElement('img');

          img.src = deleteIcon;

          ctx.save();
          ctx.translate(left, top);
          ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
          ctx.drawImage(img, -size / 2, -size / 2, size, size);
          ctx.restore();
        }
      }

      // Add button to send image to back
      addSendToBackButton(scale = 1) {
        const _this = this;

        if (scale === 0) {
          scale = 1;
        }

        fabric.Object.prototype.controls.sendToBackControl = new fabric.Control({
          x: 0.5,
          y: -0.5,
          sizeX: 32 * (1 / scale),
          sizeY: 32 * (1 / scale),
          offsetX: -56 * (1 / scale),
          offsetY: -32 * (1 / scale),
          cursorStyle: 'pointer',
          mouseUpHandler: sendToBack,
          render: renderIcon,
          cornerSize: 0
        });

        // Handle sending image to back
        function sendToBack(_eventData, transform) {
          const target = transform.target;

          _this.canvas.sendToBack(target);
          _this.canvas.requestRenderAll.bind(_this.canvas);
          _this.saveCanvas();
        }

        // Create the send to back button
        function renderIcon(ctx, left, top, _styleOverride, fabricObject) {
          const sendToBackIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='33' height='33' viewBox='0 0 33 33'%3E%3Cg id='Btn_1_' data-name='Btn (1)' transform='translate(-0.5)'%3E%3Crect id='Rectangle_1' data-name='Rectangle 1' width='32' height='32' rx='3.5' transform='translate(1 0.5)' fill='%236a7578'/%3E%3Crect id='Rectangle_2' data-name='Rectangle 2' width='32' height='32' rx='3.5' transform='translate(1 0.5)' fill='none' stroke='%236a7578' stroke-width='1'/%3E%3Cpath id='Path_1' data-name='Path 1' d='M20.5,25.1l4.012-4.012-.729-.729-2.767,2.767V11H19.984V23.124l-2.767-2.767-.729.729Z' transform='translate(-3.5 -2.952)' fill='%23fefdfc'/%3E%3Cpath id='Path_2' data-name='Path 2' d='M13,29.151H28.5v-1H13Z' transform='translate(-3.574 -5.094)' fill='%23fefdfc'/%3E%3C/g%3E%3C/svg%3E%0A";

          const size = 32 * (1 / scale);
          const img = document.createElement('img');

          img.src = sendToBackIcon;

          ctx.save();
          ctx.translate(left, top);
          ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
          ctx.drawImage(img, -size / 2, -size / 2, size, size);
          ctx.restore();
        }
      }

      // Add button to bring image to front
      addBringToFrontButton(scale = 1) {
        const _this = this;

        if (scale === 0) {
          scale = 1;
        }

        fabric.Object.prototype.controls.bringToFrontControl = new fabric.Control({
          x: 0.5,
          y: -0.5,
          sizeX: 32 * (1 / scale),
          sizeY: 32 * (1 / scale),
          offsetX: -96 * (1 / scale),
          offsetY: -32 * (1 / scale),
          cursorStyle: 'pointer',
          mouseUpHandler: bringToFront,
          render: renderIcon,
          cornerSize: 0
        });

        // Handle bringing image to front
        function bringToFront(_eventData, transform) {
          const target = transform.target;

          _this.canvas.bringToFront(target);
          _this.canvas.requestRenderAll.bind(_this.canvas);
          _this.saveCanvas();
        }

        // Create the bring to front button
        function renderIcon(ctx, left, top, _styleOverride, fabricObject) {
          const bringToFrontIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='33' height='33' viewBox='0 0 33 33'%3E%3Cg id='Btn_2_' data-name='Btn (2)' transform='translate(-0.5)'%3E%3Crect id='Rectangle_3' data-name='Rectangle 3' width='32' height='32' rx='3.5' transform='translate(1 0.5)' fill='%236a7578'/%3E%3Crect id='Rectangle_4' data-name='Rectangle 4' width='32' height='32' rx='3.5' transform='translate(1 0.5)' fill='none' stroke='%236a7578' stroke-width='1'/%3E%3Cpath id='Path_3' data-name='Path 3' d='M20,11l4.012,4.012-.729.729-2.767-2.767V25.1H19.484V12.974l-2.767,2.767-.729-.729Z' transform='translate(-3.387 -2.952)' fill='%23fefdfc'/%3E%3Cpath id='Path_4' data-name='Path 4' d='M12.5,29.151H28v-1H12.5Z' transform='translate(-3.426 -5.094)' fill='%23fefdfc'/%3E%3C/g%3E%3C/svg%3E%0A";

          const size = 32 * (1 / scale);
          const img = document.createElement('img');

          img.src = bringToFrontIcon;

          ctx.save();
          ctx.translate(left, top);
          ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
          ctx.drawImage(img, -size / 2, -size / 2, size, size);
          ctx.restore();
        }
      }

      // Handle saving the canvas
      saveCanvas(backgroundImage = null) {
        // Creates a JSON representation of the canvas data
        const canvasData = this.canvas.toDatalessJSON();

        if (backgroundImage) {
          canvasData.backgroundImage = backgroundImage;
        }

        canvasData.objects.forEach(object => {
          if (object.clipPath) {
            object.clipPath.path = clipPathString;
          }
        });

        this.moodBoard.mood_board = canvasData;
        this.data.customerMoodboards[this.moodBoardIndex]['mood_board'] = canvasData;
        this.moodBoard = this.data.customerMoodboards[this.moodBoardIndex];

        this.saving = true;

        writeRequest({
          metafield: this.data.metafield,
          moodboard: this.moodBoard,
        })
          .then(() => {
            this.readSingle(this.moodBoard.id, false);
            this.saving = false;
          })
          .catch(error => console.error(error))
      }

      // Loads canvas data from API response
      loadCanvasJSON() {
        this.canvas.loadFromJSON(this.moodBoard.mood_board, () => {
          const objects = this.canvas.getObjects();

          objects.forEach((object) => {
            this.updateControls(object);
            this.addSendToBackButton();
            this.addBringToFrontButton();
            this.addDeleteButton();
          });

          this.canvas.backgroundImage.scaleToWidth(this.canvas.width);
          this.canvas.backgroundImage.scaleToHeight(this.canvas.height);

          this.canvas.renderAll();

          this.resize();
        });
      }

      printCanvas() {
        const canvasImage = document.querySelector('.js-moodboard-canvas-image');

        if (!canvasImage) {
          return;
        }

        canvasImage.addEventListener('load', () => window.print(), { once: true });

        const dataUrl = this.canvas.toDataURL({
          format: 'jpeg',
          quality: 0.8
        });

        canvasImage.src = dataUrl;
      }

      shareCanvas() {
        const a = document.createElement('a');
        const dataUrl = this.canvas.toDataURL({
          format: 'jpeg',
          quality: 0.8
        });

        a.href = dataUrl;
        a.download = `${this.moodBoard.title}.jpg`;
        a.click();
        a.remove();
      }
    }

    customElements.define('mood-board', MoodBoard);
  }

  // Add product to mood board favourites
  if (!customElements.get('mood-board-add')) {
    class MoodBoardAdd extends HTMLElement {
      constructor() {
        super();
        this.data = JSON.parse(this.querySelector('.js-mood-board-product-data').textContent);
        this.addListeners();
      }

      addListeners() {
        this.addEventListener('click', () => {
          document.dispatchEvent(new Event('moodboardModal:show'));

          // Get list of customer mood boards
          readRequest().then(moodboards => {
            if (moodboards.customerMoodboards) {
              this.populateModal(moodboards, this.data);
            } else {
              console.error(moodboards)
            }
          });
        });
      }

      populateModal(moodboards, data) {
        // Display list of customer mood boards in modal
        document.dispatchEvent(new CustomEvent('moodboardModal:populate', {
          detail: {
            moodboards,
            data,
          },
        }));
      }
    }

    customElements.define('mood-board-add', MoodBoardAdd);
  }

  // Mood board modal
  if (!customElements.get('mood-board-modal')) {
    class MoodBoardModal extends HTMLElement {
      constructor() {
        super();
        this.productData = [];
        this.data = [];
        this.product = this.querySelector('.js-mood-board-modal-product');
        this.list = this.querySelector('.js-mood-board-modal-list');
        this.added = this.querySelector('.js-mood-board-modal-added');
        this.message = this.querySelector('.js-mood-board-modal-message');
        this.viewMoodboard = this.querySelector('.js-mood-board-modal-view');
        this.moodboardBaseUrl = '/pages/mood-board?id='
        this.addedBannerTarget = '.breadcrumb' // inserted after this element
        this.addListeners();
      }

      addListeners() {
        const saveButton = this.querySelector('.js-mood-board-modal-save');

        if (saveButton) {
          saveButton.addEventListener('click', () => this.saveModal())
        }

        const closeButtons = this.querySelectorAll('.js-mood-board-modal-close');

        if (closeButtons.length > 0) {
          closeButtons.forEach(button => button.addEventListener('click', () => this.closeModal()))
        }

        this.list.addEventListener('click', () => {
          this.message.innerHTML = '';
          this.alreadyAdded = false;
        });

        this.viewMoodboard.addEventListener('click', () => window.open(this.moodboardlUrl, '_blank'));

        document.addEventListener('moodboardModal:show', () => this.showModal());

        document.addEventListener('moodboardModal:populate', e => {
          if (!e.detail.moodboards || !e.detail.data) {
            return;
          }

          this.populateModal(e.detail.moodboards, e.detail.data);
        });
      }

      showModal() {
        this.classList.add('active', 'loading');
      }

      closeModal() {
        this.classList.remove('active', 'adding');

        if (!this.list) {
          return;
        }

        this.refreshModal();
      }

      refreshModal() {
        this.product.innerHTML = '';
        this.list.innerHTML = '';
        this.added.innerHTML = '';
        this.message.innerHTML = '';
        this.classList.remove('added');
        this.alreadyAdded = false;
      }

      // Displays list of customer mood boards in modal
      populateModal(moodboards, data) {
        if (!this.list) {
          return;
        }

        this.data = moodboards;
        this.productData = data;
        this.list.innerHTML = '';
        this.classList.remove('none-found');
        this.classList.remove('loading');

        if (this.productData.image) {
          this.product.innerHTML += `
            <div class="mood-board-modal__product-image js-mood-board-modal-product-image">
              <img src=${this.productData.image} width="170" height="170"/>
            </div>
          `
        }

        if (this.productData.title) {
          this.product.innerHTML += `
            <div class="mood-board-modal__product-title js-moodboard-product-title">
              ${this.productData.title}
            </div>
          `;
        }

        const choosable = moodboards.customerMoodboards.filter(board => !isAbandoned(board));

        if (!choosable.length) {
          const html = `<p>${window.moodBoardStrings.noMoodboards}</p>`;

          this.list.innerHTML = html;
          this.classList.add('none-found');
          return;
        }

        // Sort mood boards so most recent is first
        const orderedMoodboards = choosable.sort((a, b) => a.id < b.id ? 1 : -1);

        orderedMoodboards.forEach((item, index) => {
          const html = `
            <label
              class="mood-board-modal__label"
              for="moodboard-${item.id}"
            >
              <input
                class="js-mood-board-modal-radio visually-hidden"
                type="radio"
                id="moodboard-${item.id}"
                name="moodboard"
                value="${item.id}"
                ${index === 0 ? 'checked': ''}
              >
              <div class="mood-board-modal__radio"></div>
              ${displayTitle(item, orderedMoodboards)}
            </label>
          `;

          this.list.innerHTML += html;
        });
      }

      insertAddedBanner(productTitle, moodboardUrl) {
        const targetElement = document.querySelector(this.addedBannerTarget);

        if (!targetElement) {
          return;
        }

        if (!this.addedBanner) {
          this.addedBanner = document.createElement('div');
          this.addedBanner.classList.add('moodboard-added-banner');
          targetElement.insertAdjacentElement('afterend', this.addedBanner);
        }

        this.addedBanner.innerHTML = `
          <div class="page-width">
            <div class="moodboard-added-banner__content">
              ${
                window.moodBoardStrings.addedHtml
                  .replace('[product]', productTitle)
                  .replace('[url]', moodboardUrl)
              }
            </div>
          </div>
        `;
      }

      // Adds product to selected mood board, displays error message if product has already been added to the selected mood board
      saveModal() {
        const selectedMoodboardId = this.querySelector('.js-mood-board-modal-radio:checked').value;

        if (!selectedMoodboardId) {
          return;
        }

        const index = this.data.customerMoodboards.findIndex(({ id }) => id == selectedMoodboardId);

        if (index === -1) {
          return;
        }

        document.dispatchEvent(new Event('alert:clear'));

        this.classList.add('adding');

        const selectedMoodboard = this.data.customerMoodboards[index];

        if (selectedMoodboard.products) {
          if (selectedMoodboard.products.some(({ id }) => id == this.productData.id)) {
            this.classList.remove('adding');
            this.message.innerHTML = window.moodBoardStrings.alreadyAdded
              .replace('[product]', this.productData.title)
              .replace('[moodboard]', selectedMoodboard.title);
            this.alreadyAdded = true;
          }

          this.moodboardlUrl = this.moodboardBaseUrl + selectedMoodboard.id;
          selectedMoodboard.products.unshift(this.productData);
        } else {
          selectedMoodboard.products = []
          selectedMoodboard.products.push(this.productData);
        }

        writeRequest({
          metafield: this.data.metafield,
          moodboard: selectedMoodboard,
        })
        .then(() => {
          if (!this.alreadyAdded) {
            this.classList.add('added');
            this.added.innerHTML = window.moodBoardStrings.added
              .replace('[product]', this.productData.title)
              .replace('[moodboard]', selectedMoodboard.title);
            this.insertAddedBanner(this.productData.title, this.moodboardlUrl);
          }

          if (
            window.location.href.includes(window.moodboardRoutes.detailsPage)
            && window.location.href.includes(`id=${selectedMoodboardId}`)
          ) {
            document.dispatchEvent(new Event('moodboard:refresh'));
          }

          this.classList.remove('adding');
        })
        .catch((error) => {
          console.error(error);
          this.closeModal();
        });
      }
    }

    customElements.define('mood-board-modal', MoodBoardModal);
  }

  function stripHtml (string) {
    return string.replace(/<[^>]+>/g, '');
  }

  // A board with no name and nothing in it — no saved products, nothing on the
  // canvas. Almost all were made by a click on Create New back when that made a
  // board straight away (719 of them on 24 Sep 2026). They are left out wherever a
  // customer picks a board and don't count towards the limit, but their data is
  // never touched: this only decides what is shown.
  function isAbandoned(board) {
    if (!board || stripHtml(board.title || '').trim() !== '') {
      return false;
    }

    if (Array.isArray(board.products) && board.products.length) {
      return false;
    }

    let canvas = board.mood_board;

    if (typeof canvas === 'string') {
      try {
        canvas = JSON.parse(canvas);
      } catch (error) {
        return false;
      }
    }

    return !(canvas && Array.isArray(canvas.objects) && canvas.objects.length);
  }

  // What a board is called on screen. An unnamed board that does have something
  // in it shows the store's "Untitled Moodboard" rather than a blank — display
  // only; nothing is saved, so the name prompt still asks when it is opened.
  function hasTitle(board) {
    return !!board && stripHtml(board.title || '').trim() !== '';
  }

  // With more than one, they are numbered in the order they were made (by id,
  // oldest first) so they can be told apart — in the heart's list especially.
  // 54 customers had two or more on 24 Sep 2026. The numbers are worked out on
  // the fly, so naming one renumbers the rest; a lone one stays unnumbered.
  function displayTitle(board, boards = []) {
    if (hasTitle(board)) {
      return board.title;
    }

    const untitled = boards
      .filter(item => !hasTitle(item) && !isAbandoned(item))
      .sort((a, b) => a.id - b.id);

    if (untitled.length < 2) {
      return window.moodBoardStrings.untitled;
    }

    return `${window.moodBoardStrings.untitled} ${untitled.findIndex(item => item.id == board.id) + 1}`;
  }

  // Get customer mood boards
  function readRequest() {
       return new Promise((resolve) => {
      fetch(`https://${window.routes.store_url}/tools/mood-boards-app/mood-boards`)
        .then(response => response.json())
        .then(data => resolve(data.moodboards))
        .catch(error => resolve(error));
    });
  }

  function readSingleRequest(moodboardId) {
    return new Promise((resolve) => {
      fetch(`https://${window.routes.store_url}/tools/mood-boards-app/mood-boards/${moodboardId}`)
        .then(response => response.json())
        .then(data => resolve({
          moodboard: data.moodboard,
          metafield: data.metafield,
        }))
        .catch(error => resolve(error))
    })
  }

  // Update customer mood boards
  function writeRequest(data) {
    return new Promise((resolve) => {
      const body = JSON.parse(JSON.stringify(data));

      let products = [];

      if (body.moodboard.products) {
        body.moodboard.products.forEach(product => products.push(product.id));
      }

      body.moodboard.products = products;

      fetch(`https://${window.routes.store_url}/tools/mood-boards-app/mood-boards`, {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          'accept': 'application/json'
        },
        body: JSON.stringify(body),
      })
        .then(response => {
          if (response.ok) {
            return response.json();
          }

          if (response.status === 413) {
            const moodBoardMain = document.querySelector('.js-mood-board-main');

            objectsError = true;

            if (moodBoardMain) {
              moodBoardMain.classList.remove('loading', 'edit');
            }

            return document.dispatchEvent(new CustomEvent('alert:show', {
              detail: {
                message: window.moodBoardStrings.objectsLimit,
                status: 'error',
              },
            }));
          }

          document.dispatchEvent(new CustomEvent('alert:show', {
            detail: {
              message: window.moodBoardStrings.error,
              status: 'error',
            },
          }));
        })
        .then(data => {
          if (data.moodboards) {
            resolve(data.moodboards.customerMoodboards);

            if (objectsError) {
              document.dispatchEvent(new CustomEvent('alert:show', {
                detail: {
                  message: window.moodBoardStrings.saved,
                  status: 'success',
                },
              }));

              objectsError = false;
            }
          }
        })
        .catch(error => console.error(error));
    });
  }

  function removeRequest(moodboardId) {
    return new Promise((resolve) => {
      fetch(`https://${window.routes.store_url}/tools/mood-boards-app/mood-boards/${moodboardId}`, {
        method: 'DELETE',
        headers: {
          'content-type': 'application/json',
          'accept': 'application/json',
        },
      })
        .then(response => {
          if (response.ok) {
            return response.json();
          }

          if (response.status === 413) {
            const moodBoardMain = document.querySelector('.js-mood-board-main');

            objectsError = true;

            if (moodBoardMain) {
              moodBoardMain.classList.remove('loading', 'edit');
            }

            return document.dispatchEvent(new CustomEvent('alert:show', {
              detail: {
                message: window.moodBoardStrings.objectsLimit,
                status: 'error',
              },
            }));
          }

          document.dispatchEvent(new CustomEvent('alert:show', {
            detail: {
              message: window.moodBoardStrings.error,
              status: 'error',
            },
          }));
        })
        .then(data => {
          if (data.moodboards) {
            resolve(data.moodboards.customerMoodboards);

            if (objectsError) {
              document.dispatchEvent(new CustomEvent('alert:show', {
                detail: {
                  message: window.moodBoardStrings.removed,
                  status: 'success',
                },
              }));

              objectsError = false;
            }
          }
        })
        .catch(error => console.error(error));
    });
  }
})();
